import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth'

// Import global theme styles
import '@theme/global.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Initialize auth store - check for existing session
const authStore = useAuthStore(pinia)
authStore.initFromStorage()

app.mount('#app')
